import { Component, Inject, Output, EventEmitter } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { AssessmentResult, Course } from '@shared/models';

@Component({
  selector: 'assessment-report-dialog',
  templateUrl: './assessment-report-dialog.component.html'
})
export class AssessmentReportDialogComponent {
  @Output() onExplore = new EventEmitter<{ sessionId: string, userName: string, course: Course }>();

  public course: Course;
  public assessmentResult?: AssessmentResult;
  public errorMessage?: string;

  constructor(
    public _dialogRef: MatDialogRef<AssessmentReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: { assessment?: AssessmentResult, course: Course }
  ) {
    this.assessmentResult = _data.assessment;
    this.course = _data.course;
  }

  public setReport(report?: AssessmentResult, errorMessage: string | undefined = undefined) {
    this.assessmentResult = report;
    this.errorMessage = errorMessage;
  }

  showSessionLogs() {
    this._dialogRef.close();
    this.onExplore.emit({
      sessionId: this.assessmentResult.session_id,
      userName: this.assessmentResult.session?.actor_name,
      course: this.course
    });
  }

  close() {
    this._dialogRef.close();
  }
}
